import dynamic from 'next/dynamic'

const MapText = dynamic(() => import('../components').then(mod => mod.MapText))
const HeroSlider = dynamic(() => import('../components').then(mod => mod.HeroSlider))
const ThreeColList = dynamic(() => import('../components').then(mod => mod.ThreeColList))
const MainContainer = dynamic(() => import('../components').then(mod => mod.MainContainer))
const MediaListText = dynamic(() => import('../components').then(mod => mod.MediaListText))
const MediaText = dynamic(() => import('../components').then(mod => mod.MediaText))
const HeroCareers = dynamic(() => import('../components').then(mod => mod.HeroCareers))

import { isObjectEmpty } from '../utils'
import { fetchPageByGql } from '../services'
import { PAGE_ABOUT } from '../services/queries/pages'
import getGlobalData from '../services/cacheGlobalData'
import { STATIC_PAGE_WP_IDS } from '../utils/siteConfig'

/**
 * Fixed Page - About
 */
export default function About({ pageData }) {
  // const heroSliderData = pageData?.signaturePageAboutFields?.header
  // const threeColListData = pageData?.signaturePageAboutFields?.ourValuesThreeColumnsList
  // const mapTextData = pageData?.signaturePageAboutFields?.whereWeBuildMapText

  // let leadershipTeamData = pageData?.signaturePageAboutFields?.leadershipTeam
  // leadershipTeamData.items = leadershipTeamData?.items?.map((item, index) => {
  //   item.cta = {
  //     name: `leader-${index}`,
  //     label: 'Read Biography',
  //     type: 'modal',
  //   }

  //   return item
  // })

  const header = pageData?.dovetailPageAbout?.header
    const whereWeBuildContent = pageData?.dovetailPageAbout?.whereWeBuildContent
  const howWeBuildContent = pageData?.dovetailPageAbout?.howWeBuildContent
  const preconstructionContent = pageData?.dovetailPageAbout?.preconstructionContent
  const actualConstructionContent = pageData?.dovetailPageAbout?.actualConstructionContent
  const keepingOurPromisesContent = pageData?.dovetailPageAbout?.keepingOurPromisesContent
  const ourHistoryContent = pageData?.dovetailPageAbout?.ourHistoryContent 

  return (
    <MainContainer>
      <HeroSlider
        heroHeading={header?.mainTitle}
        heading={header?.headerTitle}
        subHeading={header?.headerHeading}
        heroVideo={header?.video?.mediaItemUrl}
        sliderImages={[{ image: header?.image }]}
        description={header?.headerDescription}
      />

      <div className={'md:mt-150'}>
        <MediaText
          image={whereWeBuildContent?.image}
          imageTitle={whereWeBuildContent?.imageTitle}
          imageSubtitle={whereWeBuildContent?.imageSubtitle}          
          heading={whereWeBuildContent?.title}
          subHeading={whereWeBuildContent?.headline}
          description={whereWeBuildContent?.description}
          cta={whereWeBuildContent.link}
          imagePosition='right'
          aspectRatio='aspect-w-3 aspect-h-5 md:aspect-w-7 md:aspect-h-12'
          hasVideoPlayback={false}
        />
      </div>

      <MediaText
        image={howWeBuildContent?.image}
        imageTitle={howWeBuildContent?.imageTitle}
        imageSubtitle={howWeBuildContent?.imageSubtitle}
        imageHeadingClass={'top-200 right-20 md:right-40'}
        heading={howWeBuildContent?.title}
        subHeading={howWeBuildContent?.headline}
        description={howWeBuildContent?.description}
        cta={howWeBuildContent.link}
        imagePosition='left'
        aspectRatio='aspect-w-3 aspect-h-5 md:aspect-w-7 md:aspect-h-12'
        hasVideoPlayback={false}
        sectionContainerClassName={'bg-transparent sm:bg-transparent'}
        isHomePage={true}
      />

      { !!preconstructionContent.visible &&
        <MediaListText
          className='py-65 md:py-150'
          background='bg-background'
          image={preconstructionContent?.image}
          heading={preconstructionContent?.title}
          subHeading={preconstructionContent?.headline}
          accordianItems={preconstructionContent?.items}          
          imagePosition={'right'}
          opened={true}
        />
      }
      
      { !!actualConstructionContent.visible &&
        <MediaListText
          className='py-65 md:py-150'
          background='bg-transparent'
          image={actualConstructionContent?.image}
          heading={actualConstructionContent?.title}
          subHeading={actualConstructionContent?.headline}
          accordianItems={actualConstructionContent?.items}
          imagePosition={'left'}
          opened={true}
        />
      }

      { !!keepingOurPromisesContent.visible &&
        <MediaListText
          className='py-65 md:py-150'
          background='bg-background'
          image={keepingOurPromisesContent?.image}
          heading={keepingOurPromisesContent?.title}
          subHeading={keepingOurPromisesContent?.headline}
          accordianItems={keepingOurPromisesContent?.items}
          imagePosition={'right'}
          opened={true}
        />
      }

      <MediaText        
        image={ourHistoryContent?.image}
        secondaryImage={ourHistoryContent?.secondaryImage}
        heading={ourHistoryContent?.title}
        subHeading={ourHistoryContent?.headline}
        description={ourHistoryContent?.description}        
        imagePosition='left'
        aspectRatio='aspect-w-3 aspect-h-5 md:aspect-w-7 md:aspect-h-12'
        hasVideoPlayback={false}        
        sectionContainerClassName={'bg-transparent sm:bg-transparent'}
      />
    </MainContainer>
  )
}

export async function getStaticProps({ preview = false }) {
  const query = PAGE_ABOUT
  const params = { pageId: STATIC_PAGE_WP_IDS?.about }

  const pageData = await fetchPageByGql(query, params, preview)
  const globalData = await getGlobalData()

  return isObjectEmpty(pageData)
    ? { notFound: true } // returns custom 404 page
    : { props: { preview, pageData, globalData } }
}
